<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmtasktype.list.table.title') }}:</label>
            <input v-model.lazy="filters.title" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmtasktype.form.idCasesType') }}:</label>
            <model-select :options="caseTypesOptions" v-model="filters.idCasesType"></model-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import ApiService from '@/utils/ApiService'
import { ModelSelect } from 'vue-search-select'
export default {
  name: 'TaskTypeFiltering',
  components: {
    ModelSelect
  },
  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        title: '',
        state: 1
      },
      statuses: [],
      caseTypesOptions: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.$emit('addToSearchParams', this.filters)
      }
    }
  },

  created () {
    this.getCaseTypes()
  },

  methods: {
    async getCaseTypes () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_c_m_case_types', params).getResults()
      this.caseTypesOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      this.caseTypesOptions.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
    }
  }
}
</script>
